import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { FormFilterSavedSearchesService } from '@app/modules/table/services/form-filter-saved-searches.service';

/**
 * Сервис, управляющий фильтром таблицы
 */
@Injectable()
export class FormFilterTableControlService {
    public readonly savedSerchesService: FormFilterSavedSearchesService = inject(FormFilterSavedSearchesService);
    readonly #isFilter$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    readonly #isOpenFilter$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    readonly #isFilterSet$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    readonly #recordsFound$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
    readonly #filterChanged$: Subject<void> = new Subject<void>();

    /**
     * Наличие фильтра
     */
    public get isFilter$() {
        return this.#isFilter$.asObservable();
    }

    public set isFilter(flag: boolean) {
        if (flag !== this.isFilter) {
            this.#isFilter$.next(flag);
        }
    }

    public get isFilter() {
        return this.#isFilter$.value;
    }

    /**
     * Фильтр отображается (открыт-закрыт) - форма редактирования
     */
    public get isOpenFilter$() {
        return this.#isOpenFilter$.asObservable();
    }

    public set isOpenFilter(flag: boolean) {
        if (flag !== this.isOpenFilter) {
            this.#isOpenFilter$.next(flag);
        }
    }

    public get isOpenFilter() {
        return this.#isOpenFilter$.value;
    }

    public clear() {
        this.savedSerchesService.filterRecords = [];
        this.savedSerchesService.select(null);
    }

    /**
     * Фильтр применен
     */
    public get isFilterSet$() {
        return this.#isFilterSet$.asObservable();
    }

    public set isFilterSet(flag: boolean) {
        if (flag !== this.isFilterSet) {
            this.#isFilterSet$.next(flag);
            // Проверям чипсы при изменении фильтра
            this.setFilterChanged();
        }
    }

    public get isFilterSet() {
        return this.#isFilterSet$.value;
    }

    /**
     * Сколько записей нашел фильтр
     */
    public get recordsFound$() {
        return this.#recordsFound$.asObservable();
    }

    public set recordsFound(quantity: number) {
        this.#recordsFound$.next(quantity);
    }

    public get recordsFound() {
        return this.#recordsFound$.value;
    }

    /**
     * Событие изменения параметров фильтрации
     */
    public get filterChanged$() {
        return this.#filterChanged$.asObservable();
    }

    public setFilterChanged() {
        this.#filterChanged$.next();
    }
}
